import React from 'react';
import IntroBlock from './components/Intro/Intro';
import BrandsPartnerships from './components/Brands/Brands';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import TailorSection from './components/TailorSection/TailorSection';
import BrandsRuningStroke from './components/BrandsRuningStroke/BrandsRuningStroke';

const CraftsmenSubpage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('Craftsmen Cooperations - Become part of the Repair Rebels network')}</title>
        <meta name="description" content={t('Meta Craftsmen Descriptionn')} />
      </Helmet>
      <div className="container">
        <IntroBlock />
      </div>
      <div style={{ background: '#ffffff' }}>
        <BrandsRuningStroke />
      </div>
      <div>
        <BrandsPartnerships />
      </div>
      <div className="container">
        <TailorSection />
      </div>
    </>
  );
};

export default CraftsmenSubpage;
